export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/b94cdee409f55382a26c8aa8c74f2625.png";